import React from 'react';
import { Skeleton } from '../ui/skeleton';

const Spinner = () => (
  <div className="flex items-center justify-center p-4">
    <Skeleton className="h-6 w-6 rounded-full bg-green-100" />
  </div>
);

export default Spinner;